let getters = {
  transactions ( state ) {
    return state.transactions
  },
  totalTxnCount ( state ) {
    return state.totalTxnCount
  },
  csv ( state ) {
    return state.csv
  },
  allTransactions ( state ) {
    return state.allTransactions
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/transactions/getters.js